'use client';

import React, { FC } from 'react';

import PartCasesContainer from '@/components/part-cases-container';
import PartSectionContainer from '@/components/UI/part-section-container/part-section-container';
import { IListCases } from '@/contentful/utils/cases';
import { ILanguage } from '@/context/LanguageContext';

import styles from './part-other-cases.module.scss';

interface IPartCasesProps {
  data: {
    lang: ILanguage;
    otherCasesCategory: string | undefined;
    otherCasesTitle: string | undefined;
    otherCases: IListCases[];
  };
}

const PartOtherCases: FC<IPartCasesProps> = ({
  data: {
    otherCasesCategory, otherCasesTitle, otherCases, lang,
  },
}) => (
  <section className={styles.container}>
    <PartSectionContainer
      advantage={otherCasesCategory ?? ''}
      title={otherCasesTitle ?? ''}
    >
      <PartCasesContainer cases={otherCases} lang={lang} full={false} />
    </PartSectionContainer>
  </section>
);

export default PartOtherCases;
